import * as _ from 'lodash'
import {
  IHavePlanMetricsChangedEvent,
  IPlanStandardCalculatorClientExtension,
  ITPMPlanChangedEvent
} from "../../PA.TPM.Core/PA.TPM.IF.TPM.Plan.Aspects";
import {TPMPlanBO} from "../../PA.TPM.BusinessObjects/TPMPlanBO";
import {TPMPlanStandardCalculatorUtils} from "../TPMPlanStandardCalculatorUtils";
import {NumberUtils} from "../../PA.Core/Basic/Numbers";


let PSCHainAdvanced: IPlanStandardCalculatorClientExtension = {

  get id(): string {
    return "HainAdvancedExtension"
  },


  OnProductGroupAdded: function (aTPMPlanBO: TPMPlanBO) {
    console.log("OnProductGroupAdded: ")

    return this._applyBaseline(aTPMPlanBO, true, true)
  },

  OnTPMPlanPropertyChange: function (aTPMPlanBO: TPMPlanBO, change: ITPMPlanChangedEvent) {
    const self = this

    return new Promise<boolean>((resolve, error) => {

      // aTPMPlanBO.WB_Plan.cif.WB_BASELINE_ID_ALT
      console.log("OnTPMPlanPropertyChange: ", change.PropertyChanged, " : ", change.PropertyValue)
      switch (change.PropertyChanged) {

        case 'WB_BASELINE_ID_PY':
          self._applyBaseline(aTPMPlanBO, true, false)
            .then((ignore: any) => {
              resolve(true)
            })
            .catch((err: any) => {
              error(err)
            })
          break;

        case 'WB_BASELINE_ID_ALT':
          self._applyBaseline(aTPMPlanBO, false, true)
            .then((ignore: any) => {
              resolve(true)
            })
            .catch((err: any) => {
              error(err)
            })
          break;

      }

    });
  },

  OnTPMPlanVolumeMetricPropertyChange: function (aTPMPlanBO: TPMPlanBO, change: IHavePlanMetricsChangedEvent) {
    const self = this

    return new Promise<boolean>((resolve, error) => {
      if (_.isEmpty(aTPMPlanBO)) {
        resolve(true);
        return
      }

      let aRow = change.Row.cif

      switch (change.PropertyChanged) {

        case "CNS_BASELN_CY_QTY":
          case "CNS_BASELN_ADJ_QTY":
          aRow.CNS_BASELN_EFF_QTY = NumberUtils.round(_.toNumber(aRow.CNS_BASELN_CY_QTY) + _.toNumber(aRow.CNS_BASELN_ADJ_QTY),6)
          aRow.SHIP_BASELN_EFF_QTY = NumberUtils.round(_.toNumber(aRow.CNS_BASELN_EFF_QTY),6)
          break;

        case "SHIP_BASE_QTY":
        case "SHIP_INCR_QTY":
        case "SHIP_FORWARDBUY_QTY":
        case "SHIP_ADJ_QTY":
          aRow.SHIP_TOTAL_QTY = NumberUtils.round(_.toNumber(aRow.SHIP_BASE_QTY) + _.toNumber(aRow.SHIP_INCR_QTY) + _.toNumber(aRow.SHIP_FORWARDBUY_QTY) + _.toNumber(aRow.SHIP_ADJ_QTY),6)
          break;

      }

    })
  },

  ApplyBaseline(aTPMPlanBO: TPMPlanBO, bIncludePY: boolean, bIncludeAlt: boolean) {
    const self = this

    return self._applyBaseline(aTPMPlanBO, bIncludePY, bIncludeAlt)
  },


  _applyBaseline(aTPMPlanBO: TPMPlanBO, bIncludePY: boolean, bIncludeAlt: boolean): Promise<void> {
    const self = this

    return new Promise<void>((resolve, error) => {

      let args: any = {}
      let aPYBaselineId = _.toNumber(aTPMPlanBO.WB_Plan.cif.WB_BASELINE_ID_PY)
      let aAltBaselineId = _.toNumber(aTPMPlanBO.WB_Plan.cif.WB_BASELINE_ID_ALT)

      if(bIncludePY) {
          args['CNS_BASELN_PY_QTY'] = {wb_baseln_id: (aPYBaselineId > 0)?aPYBaselineId:0 }
      }

      if (bIncludeAlt){
        args['CNS_BASELN_ALT_QTY'] = {wb_baseln_id: (aAltBaselineId > 0)?aAltBaselineId:0 }
      }

      if (_.isEmpty(args)) {
        resolve()
        return
      }

      TPMPlanStandardCalculatorUtils.applyBaseline(aTPMPlanBO, args)
        .then((ignore) => {
          resolve()
        })
        .catch((err) => {
          error(err)
        })

    });
  }


}

export {PSCHainAdvanced}
